import { defineAsyncComponent } from 'vue'

const modalName = process.env.VUE_APP_MODAL

if (!modalName) {
    throw new Error('VUE_APP_MODAL is not defined in .env file!')
}

const ErrandModal = defineAsyncComponent(() =>
    import(`../components/Modals/ErrandModal-${modalName}.vue`)
)

export default {
    components: { ErrandModal }
}
